import React, { Component } from 'react';
import Footer from '../../components/layout/Footer';

import HeaderMeta from 'components/headerMeta/HeaderMeta';
import '../../assets/style/itemStyle/common.scss';

export default class AboutUs extends Component {
  render() {
    return (
      <>
        <HeaderMeta type="aboutUs" />
        <div className="public-container about-us-container">
          <div className="banner">
            <img
              src={require('../../assets/imgs/webp/about-us-banner.webp').default}
              alt="about us banner"
            />
          </div>
          <div className="public-content services">
            <div className="banner_bg bg-image">
              <div className="describe">
                <h1 style={{ color: '#fff' }}>About Us</h1>
                <p>
                  Founded in New York by a group of aviation industry professionals, Airacer is the
                  one-stop platform for your private aviation experience. Partnering with DOT/FAA
                  licensed air carriers and prestigious flight operators, Airacer provides clients
                  with the most convenient and reliable private flight services.
                </p>
                <p>
                  Since its launch in 2015, Airacer has been working effortlessly to bring private
                  aviation closer to clients all over the world by making flying accessible and
                  affordable. With unlimited access to worldwide network of aircrafts, our clients
                  can enjoy the most tailored and cost-effective services wherever they are.
                </p>
                <div
                  className="link"
                  onClick={() => {
                    this.props.history.push('/contactUs');
                  }}
                >
                  <span>Contact US</span>
                </div>
              </div>
            </div>
            <div className="title">Our services</div>
            <ul className="list">
              <li>
                <div className="text-content">
                  <h3 className="tit">
                    <span>Private Jet Charter Services</span>
                  </h3>
                  <p>
                    Elevate your travel experience with premier <b>private jet charter services</b>{' '}
                    designed to cater to the unique needs of discerning travelers. Whether you're
                    flying for business or leisure, <b>on-demand private jet charters</b> offer
                    unparalleled flexibility, luxury, and convenience. Choose from a vast selection
                    of aircraft, from light jets to long-range models, ensuring a tailored
                    experience that aligns with your specific requirements. Our{' '}
                    <b>private jet membership programs</b> provide exclusive access to a global
                    fleet, personalized service, and the freedom to fly on your terms. With no
                    upfront costs and transparent pricing, you can enjoy the ultimate luxury of
                    private aviation without any of the traditional hassles. Experience seamless,
                    efficient travel with{' '}
                    <b>direct access to thousands of private airports worldwide</b>, bypassing the
                    inconveniences of commercial flights and maximizing your time. Book your{' '}
                    <b>private jet charter</b> today and enjoy the comfort, privacy, and exceptional
                    service that set us apart in the world of luxury travel.
                  </p>
                </div>
                <a href="/charterQuote">
                  <img
                    src={require('../../assets/imgs/webp/about-us-01.jpg').default}
                    alt="Private Jet Charter Services"
                  />
                </a>
              </li>
              <li>
                <a href="/membership">
                  <img
                    src={require('../../assets/imgs/webp/about-us-02.jpg').default}
                    alt="Pet-Friendly Shared Seat Flights"
                  />
                </a>
                <div className="text-content">
                  <h3 className="tit">
                    <span>Ultimate Pet-Friendly Jet Club Membership</span>
                  </h3>
                  <p>
                    Our <b>pet-friendly membership</b> program offers premium benefits to make
                    traveling with your furry companions stress-free and luxurious. From{' '}
                    <b>waived pet handling fees</b> across all tiers to our dedicated Pet Jet Travel
                    Concierge, {"we're"} committed to ensuring pets receive exceptional care at
                    every step. Members gain access to exclusive pet travel perks like complimentary
                    upgrades and <b>tailored comfort packages</b>, while our higher tiers offer
                    unlimited pet travel and even luxury chauffeur services for seamless ground
                    transport. With options like pet passports and customized travel support,{' '}
                    <b>we make flying with pets easier and more enjoyable</b>, so you can relax and
                    focus on your journey together.
                  </p>
                </div>
              </li>
              <li>
                <div className="text-content">
                  <h3 className="tit">
                    <span>Empty Leg Services</span>
                  </h3>
                  <p>
                    Discover significant savings with <b>empty leg flights</b>, providing a
                    cost-effective way to experience the luxury of private jet travel.{' '}
                    <b>Empty legs</b>, also known as <b>one-way private jet charters</b> or{' '}
                    <b>repositioning flights</b>, occur when a private jet needs to return to its
                    base or travel to a new location without passengers. By booking these{' '}
                    <b>empty leg seats</b>, you can access the same high-quality service and comfort
                    of a private jet charter at a fraction of the regular price.
                  </p>
                  <p>
                    Our extensive network allows us to offer a wide range of{' '}
                    <b>empty leg options</b> worldwide, giving you the flexibility to find routes
                    that match your travel needs. Whether {"you're"} looking for spontaneous travel
                    or planning ahead, our team can help you identify the best available{' '}
                    <b>empty leg opportunities</b>. Stay updated with real-time availability through
                    our platform, where you can <b>book empty leg flights</b> seamlessly. Embrace
                    the convenience, affordability, and luxury of private jet travel with exclusive{' '}
                    <b>empty leg services</b>.
                  </p>
                </div>
                <a href="/emptyLeg">
                  <img
                    src={require('../../assets/imgs/webp/about-us-03.jpg').default}
                    alt="Empty Leg Services"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}
